import { ArrowRight, BellRing, CalendarDays, MonitorSmartphone } from "lucide-react";

export default function CtaSection() {
  return (
    <section className="rz-section rz-section--dark rz-cta">
      <div className="rz-shell rz-cta-box">
        <div className="rz-cta-content">
          <p className="rz-kicker">Hai să vedem ce variantă ți se potrivește</p>

          <h2>Vrei o prezentare mai bună și un mod mai clar prin care clienții să trimită cereri directe?</h2>

          <p className="mt-5">
            Spune-ne cum funcționează acum businessul tău și îți propunem varianta potrivită: de la o soluție simplă pe email, până la un sistem complet de administrare.
          </p>

          <div className="rz-cta-features mt-5">
            <span><CalendarDays size={16} /> Flux mai clar pentru cereri</span>
            <span><MonitorSmartphone size={16} /> Prezentare optimizată pentru mobil</span>
            <span><BellRing size={16} /> Notificări rapide și administrare simplă</span>
          </div>

          <a href="#lead-form" className="rz-btn rz-btn--primary mt-5">
            Solicită o prezentare
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}
